.progressBar {
    position: relative;
    width: 100%;
    height: 2px;
    background: linear-gradient(
        90deg,
        var(--accent) var(--scroll-progress-percent),
        var(--progress-track) var(--scroll-progress-percent)
    );
}
